import PropTypes from 'prop-types'
import classNames from 'classnames'

const StoreItemDetail = ({
  locationImage,
  name,
  address,
  phones,
  schedule,
  url,
  tour,
  location
}) => {
  const tourButtonClasses = classNames({
    'button-full': true,
    'button-hollow-primary': true,
    'button-hollow': true,
    'margin-right-small': true,
    'align-center': true,
    disabled: !tour
  })

  return (
    <div className="col-xs-12">
      <div className="col-xs-12 col-xl-6">
        <a href={ url }>
          <h5 className="heading-5 color-primary">{ name }</h5>
          <div className="store-item-description">
            <p className="store-address no-margin">{ address }</p>
            <p className="store-phones margin-y-small">Fone { phones }</p>
            <p className="store-schedule margin-y-small">
              Segunda à sábado { schedule.weekdays[0] } - { schedule.weekdays[1] } / domingos e feriados { schedule.sunday[0] } - { schedule.sunday[1] }
            </p>
          </div>
        </a>
        <div className="store-item-buttons">
          <a
            href={ tour }
            className={ tourButtonClasses }
            target="_blank"
            rel="noopener nofollow"
            data-tour-link>
            Tour 360°
          </a>
          <a
            href={`https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lon}`}
            className="button-full button-hollow-primary button-hollow margin-left-small align-center"
            target="_blank"
            rel="noopener nofollow"
            data-directions-link>
            Como chegar
          </a>
        </div>
      </div>

      <div className="col-xs-12 col-xl-6 margin-top-double">
        <div className="maps">
          <img className="image" src={ locationImage } />
        </div>
      </div>
    </div>
  )
}

StoreItemDetail.propTypes = {
  locationImage: PropTypes.string,
  name: PropTypes.string,
  address: PropTypes.string,
  phones: PropTypes.string,
  schedule: PropTypes.shape({
    saturday: PropTypes.arrayOf(PropTypes.string),
    sunday: PropTypes.arrayOf(PropTypes.string),
    weekdays: PropTypes.arrayOf(PropTypes.string)
  }),
  url: PropTypes.string,
  tour: PropTypes.string,
  location: PropTypes.shape({
    lat: PropTypes.string,
    lon: PropTypes.string
  })
}

export default StoreItemDetail
